const QUERIES = {
  USERS_LIST: 'users-list',
  REVIEW_LIST: 'review-list',
}

export {QUERIES}
